import { Component, Input, EventEmitter, Output } from '@angular/core';
import { LoadingController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { EventDetailsModel, EventListModel, EventProvider } from '../../providers/event/event';
import { LoaderProvider } from '../../providers/loader/loader';
import { ConfigProvider } from '../../providers/config/config';
import { NewsController } from '../../providers/news/news-contoller';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { Router } from '@angular/router';
import { NavigationService } from 'src/providers/navigation/navigation.service';

/**
 * Generated class for the EventSearchListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'event-search-list-item',
  templateUrl: 'event-search-list-item.html',
  styleUrls:['./event-search-list-item.scss']
})
export class EventSearchListItemComponent {

  @Input("event")
  event: any;

  @Input('pipeDateFormat')
  pipeDateFormat: any = "dd.MM.yyyy";

  @Input("openDetails")
  openDetails: boolean;

  @Input("order")
  order: number;//boolean

  @Output()
  onEvent: EventEmitter<string>;

  clientApp = false;
  newDesign = false;

  secondEntryLevel: boolean = false;
  mainColor: string = "black";

  constructor(
    public router:Router,
    public translate: TranslateService,
    private eventService: EventProvider,
    private loadingCtrl: LoadingController,
    public appDetector: AppDetectorProvider,
    private config: ConfigProvider,
    private navCtrl:NavController,
    private navService:NavigationService
  ) {
    new Promise(async (resolve, reject) => {
      this.onEvent = new EventEmitter<string>();
      let appId: string = (await this.config.config).appId;

      this.newDesign = (await this.config.config).showHide.newEventDesign;
      // this.newDesign = (this.newDesign) ? !this.openDetails : false;
      this.clientApp = (appId.includes('hella') || appId.includes('hannover') || appId.includes('frankfurt')) ? true : false;
      this.secondEntryLevel = (appId.includes('hella') || appId.includes('event')) ? true : false;
      this.mainColor = (await this.config.config).theme.color;
      // if (this.event && this.event.evtStat) this.timeCheck = (this.clientApp) ? (this.event.evtStat.includes('V') ? false : true) : true;
      // console.log(this.event);
    });
  }

  async openEventDetails() {
    console.log('openEventDetails')
    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    NewsController.getInstance().isAllowed = false;

    this.eventService.getEventDetails(this.event.id).then((event: EventDetailsModel) => {

      if (event.name.length < 1) {
        this.openEventDetails();
        loader.dismiss();
      } else {
        this.navCtrl.navigateForward('/tab1/event/details/tabs', {state:{event}})
        .then(() =>{
          loader.dismiss()
        });//
        // (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
      }
    })
    .catch(err => loader.dismiss());
  }

  onEventPressed() {
    if (this.openDetails) {
      this.openEventDetails();
    } else {
      this.onEvent.emit(this.event.enaOrig);
    }
  }
}
